module.exports = __webpack_public_path__ + "static/media/Ex3-S5-A.0e7675a4.PNG";